import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import Faq from "./../Faq";
import "./styles.scss";

const emptyAnswer =
  "We're looking into it! If you have suggestions, contact one of the planeteers!";

function FaqSection(props) {
  return (
    <Section color={props.color} size={props.size}>
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          centered={true}
          size={3}
        />
        <Faq
          items={[
            {
              question: "Which stores have BYO containers?",
              answer: emptyAnswer
            },
            {
              question: "What can I do today to reduce my waste?",
              answer: emptyAnswer
            },
            {
              question: "Where is my nearest community garden?",
              answer: emptyAnswer
            },
            {
              question: "What are some greener ways to commute?",
              answer: emptyAnswer
            }
          ]}
        />
      </div>
    </Section>
  );
}

export default FaqSection;
